import { useCallback } from "react";
import { usePropiedadIdioma } from "../context/PropiedadIdiomaContext";
import { translateUiString } from "../utils/propiedadUiStrings";
import { buildEsTextMapFromLabels } from "../utils/propiedadI18n";

/** t/tv para secciones de ficha: props del padre o contexto. */
export function usePropiedadUi(props = {}) {
  const ctx = usePropiedadIdioma();
  const idiomaVista = ctx.idiomaVista;
  const labelsMap = ctx.labelsMap;
  const t = props.t || ctx.t || ((_, fb) => fb);
  const esTextMap = buildEsTextMapFromLabels(labelsMap, idiomaVista);
  const tvFromCtx = useCallback(
    (text) => translateUiString(idiomaVista, text, esTextMap),
    [idiomaVista, esTextMap],
  );
  const tv = props.tv || ctx.tv || tvFromCtx;
  return {
    t,
    tv,
    idiomaVista,
    soloLecturaIdioma: props.soloLecturaIdioma ?? ctx.soloLecturaIdioma,
  };
}
